
export class PfenseRequestDto {
    public customerId :string;
    public datacenterId :string;
}
    
